import { render, staticRenderFns } from "./memberCommentBoxList.vue?vue&type=template&id=ebd48636&scoped=true"
import script from "./memberCommentBoxList.vue?vue&type=script&lang=js"
export * from "./memberCommentBoxList.vue?vue&type=script&lang=js"
import style0 from "./memberCommentBoxList.vue?vue&type=style&index=0&id=ebd48636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd48636",
  null
  
)

export default component.exports